<neo-checkbox-v2
  class="cm-checkbox"
  [class.has-hint]="hint()"
  [checked]="effectiveChecked"
  [disabled]="effectiveDisabled"
  [indeterminate]="indeterminate()"
  [aria-label]="ariaLabel()"
  (change)="onCheckboxChange($event.checked)"
>
  @if (hint()) {
    <div class="checkbox-label">
      <span class="checkbox-label__main">{{ label() }}</span>
      <span class="checkbox-label__hint">{{ hint() }}</span>
    </div>
  } @else {
    <span class="checkbox-label__main">{{ label() }}</span>
  }
</neo-checkbox-v2>
